import { render, staticRenderFns } from "./BaseBackButton.vue?vue&type=template&id=6eebcdab&scoped=true&"
import script from "./BaseBackButton.vue?vue&type=script&lang=js&"
export * from "./BaseBackButton.vue?vue&type=script&lang=js&"
import style0 from "./BaseBackButton.vue?vue&type=style&index=0&id=6eebcdab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eebcdab",
  null
  
)

export default component.exports